module.exports = __webpack_public_path__ + "img/tld.c791049b.jpg";